<template>
  <crud-editor
    :id="createCompositeId()"
    ref="editor"
    :is-edit="true"
    :definition="definition"
    :fetch-by-id="fetchByCompositeId"
    :disabled="hasNoEditPermission"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :page-loading="loading"
    :get-dependencies="getDependencies"
    :show-delete-button="false"
    :show-save-button="false"
    :show-save-and-next-button="false"
  />
</template>

<script>
import CrudEditor from '@/components/crud/Editor';
import formMixin from './form-mixin';
import { hasEditPermissionForCode } from '@/utils/permission';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    hasNoEditPermission() {
      return !hasEditPermissionForCode(this.entity, this.$store.getters.permissions);
    }
  },
  created() {
    this.$store.dispatch('currency/getItems');
    this.$store.dispatch('culture/getItems', { query: { domainID: +this.$route.params.domainID } });
  },
  methods: {
    createCompositeId() {
      return {
        priceListItemID: this.$route.params.priceListItemID,
        priceListMatrixID: this.$route.params.priceListMatrixID
      };
    },
    fetchByCompositeId(compositeId) {
      return this.$store.dispatch('priceListItem/getLastPrices', compositeId);
    },
    saveData(form) {
      const item = this.createItemFromFormData(this, form);
      return this.$store.dispatch('priceListItem/updatePricesForDate', item);
    }
  }
};
</script>
